import { List, Datagrid, TextField, 
         NumberField, 
         SelectField,
         FunctionField} from 'react-admin';


const questionTypeChoice = [
  { id: 'TEXT', name: 'Text' },
  { id: 'MCQ', name: 'Multi choices' },
  { id: 'CHECKBOX', name: 'Checkbox' },
];

const questionnaireChoice = [
  { id: 'PRE', name: 'Pre-experiment' },
  { id: 'POST', name: 'Post-experiment' },
];

export const QuestionnaireList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <SelectField source="type" choices={questionnaireChoice}/>
      <SelectField source="question_type" choices={questionTypeChoice}/>
      <TextField source="question_text" />
      <FunctionField source="created_at" 
        render={
          record => {
            return new Date(record.created_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
        }
      />
      <NumberField source="display_order"/>
      <TextField source="choices" />
    </Datagrid>
  </List>
)

export const QuestionnaireResponseList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="account_id" />
      <SelectField source="question_type" choices={questionTypeChoice}/>
      <TextField source="question_text" />
      <TextField source="answer" />

      <FunctionField source="submitted_at" 
        render={
          record => {
            return new Date(record.submitted_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
        }
      />
      <NumberField source="display_order"/>
    </Datagrid>
  </List>
);